/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_SubtitleInputs */

const cs_settings_profile_subtitle = /** @type {(inputs: Settings_Profile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Účet, veřejná vizitka a vaše kalendáře. Každý si napojí vlastní Google nebo Outlook — osobní Gmail je v pořádku.`)
};

const en_settings_profile_subtitle = /** @type {(inputs: Settings_Profile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your account, public card, and your calendars. Each person links their own Google or Outlook — personal Gmail is fine.`)
};

/**
* | output |
* | --- |
* | "Your account, public card, and your calendars. Each person links their own Google or Outlook — personal Gmail is fine." |
*
* @param {Settings_Profile_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_subtitle = /** @type {((inputs?: Settings_Profile_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_subtitle(inputs)
	return cs_settings_profile_subtitle(inputs)
});